import { Injectable, Inject, InjectionToken } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TransferState } from '@angular/platform-browser';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CommonService } from '../services/common.service';
function createDynamicStateKey<T>(key: string): InjectionToken<T> {
  return new InjectionToken<T>(`TRANSFER_STATE_KEY_${key}`);
}

@Injectable({
  providedIn: 'root',
})
export class ProductResolver implements Resolve<any> {
  private staticStoreId = 259391; // your static store ID here

  constructor(
    private commonService: CommonService,
    private state: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const productSlug:any = route.paramMap.get('CatalogItemId')!;
    const key:any = createDynamicStateKey<any>(`product-${this.staticStoreId}-${productSlug}`);
    if (this.state.hasKey(key)) {
      return of(this.state.get(key, null));
    } else {
      return this.commonService.getProductDetailsSSR(this.staticStoreId, productSlug).pipe(
        tap((data) => {
          if (!isPlatformBrowser(this.platformId)) {
            this.state.set(key, data);
          }
        })
      );
    }
  }
}
